import React from 'react';
import Layout from '../../components/Layout';
import type { WorkspaceNotice } from '../notices';
import '../workspace.css';
import { Notice } from './Notice';

interface Props {
  notice?: WorkspaceNotice | null;
  onCloseNotice?: () => void;
  basket?: React.ReactNode;
  /** Экран занимает всю ширину страницы (список тестов); остальные экраны читаются колонкой. */
  wide?: boolean;
  children: React.ReactNode;
}

/** Общая оболочка экранов рабочего места: существующий Layout и стили по дизайн-системе проекта. */
export const WorkspaceShell: React.FC<Props> = ({ notice = null, onCloseNotice, basket = null, wide = false, children }) => (
  <Layout wide>
    <div className="tw-root">
      <div className={wide ? 'tw-wrap tw-wrap-wide' : 'tw-wrap'}>
        <div className="tw-stack">
          <Notice notice={notice} onClose={onCloseNotice ?? (() => undefined)} />
          {children}
        </div>
      </div>
      {basket}
    </div>
  </Layout>
);
